// Application constants
export const APP_CONFIG = {
  name: 'Vaidvana',
  version: '1.0.0',
  description: 'Physiotherapy Practice Management System',
};

// Tunnel hostname mappings (frontend hostname → backend origin)
const TUNNEL_BACKENDS: Record<string, string> = {
  'unadded-makenna-abstentious.ngrok-free.dev': 'https://emulative-camie-foamless.ngrok-free.dev',
};

function resolveApiBaseUrl(): string {
  // 1. Explicit env var always wins
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL;

  // 2. If accessed via a known tunnel hostname, use its paired backend
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const tunnelBackend = TUNNEL_BACKENDS[host];
  if (tunnelBackend) return `${tunnelBackend}/api/v1`;

  // 3. Default — local development
  return 'http://localhost:8080/api/v1';
}

// API Configuration
export const API_CONFIG = {
  baseURL: resolveApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true', // For ngrok tunnels to prevent browser warning
  },
};

// Routing Constants
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  APPOINTMENTS: '/appointments',
  PATIENTS: '/patients',
  SETTINGS: '/settings',
  AVAILABILITY: '/availability',
  SERVICES: '/services',
};

// Date/Time Formats
export const DATE_FORMATS = {
  DISPLAY_DATE: 'dd/MM/yyyy',
  DISPLAY_TIME: 'hh:mm a',
  DISPLAY_DATETIME: 'dd/MM/yyyy hh:mm a',
  API_DATE: 'yyyy-MM-dd',
  API_DATETIME: "yyyy-MM-dd'T'HH:mm:ss",
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZES: [5, 10, 20, 50],
};